export default __webpack_public_path__ + "static/media/antelopepng.d09f7327.png";